import type { IconProps } from "./icon-types";

/**
 * point 단위로 object 영역을 지정·편집하는 Annotation 작업 — 꼭짓점 노드가 있는 다각형.
 *
 * viewfinder 코너(4귀퉁이 브래킷)는 쓰지 않는다 — capture/scan 계열(Tabler
 * capture/object-scan 등)이 점유한 메타포라 소형(14–20px)에서 실루엣이 수렴한다.
 * 대신 vector 편집 관례(Tabler polygon류)의 "다각형 + 노드 서클"로 구분하고,
 * 작은 IconButton에서 중심이 흔들리지 않도록 24 grid의 양축 대칭으로 구성한다.
 */
export const AnnotationIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="4" r="2" />
    <circle cx="20" cy="12" r="2" />
    <circle cx="12" cy="20" r="2" />
    <circle cx="4" cy="12" r="2" />
    <path d="M14 6l4 4" />
    <path d="M18 14l-4 4" />
    <path d="M10 18l-4-4" />
    <path d="M6 10l4-4" />
  </svg>
);
